
import * as twicpicsRuntime$n8mYMlkki6 from '/opt/buildhome/repo/node_modules/.pnpm/@nuxt+image@1.8.1_rollup@2.79.2/node_modules/@nuxt/image/dist/runtime/providers/twicpics'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "twicpics",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['twicpics']: { provider: twicpicsRuntime$n8mYMlkki6, defaults: {"baseURL":"https://oxbull.twic.pics/"} }
}
        